module.exports = __webpack_public_path__ + "img/gonggao.ae411ae0.png";